import { defineStore } from 'pinia'

export const useReviewStore = defineStore('review', {
  state: () => {
    return {
      reviews: [
        {
            id: 1,
            title: 'Top!',
            review: 'Enkele maanden geleden door advies van de huisarts hier terecht gekomen voor de behandeling van mijn hernia. Bart verricht wonderen !!! Natuurlijk moet je thuis ook nog aan de slag met oefeningen, maar ondertussen functioneer ik al bijna terug als vroeger. Allen daarheen zou ik zeggen, maar dan heb ikzelf binnenkort geen plaats meer 😉',
            image: require('../assets/images/work/01.jpg'),
        },
        {
            id: 2,
            title: 'Fantastisch!',
            review: 'Na enkele weken in behandeling bij Impuls ben ik eindelijk volledig verlost van mijn lage rugpijn, en daar ben ik ontzettend dankbaar voor! Robbe is niet alleen een uiterst bekwame kinesist, maar ook het zonnetje in huis die elke sessie een stuk aangenamer maakt. Hij creëert een ontspannen sfeer en maakt altijd tijd voor een fijne babbel. Hopelijk blijf ik blessurevrij, maar mocht het ooit nodig zijn, dan keer ik zonder aarzelen terug naar Impuls. Bedankt Robbe jongen voor de topzorg 👏',
            image: require('../assets/images/work/01.jpg'),
        },
        {
          id: 3,
          title: 'Professionele begeleiding',
          review: 'Vanaf de eerste sessie bij Impuls voelde ik me in goede handen. Bram nam de tijd om mijn klachten grondig te analyseren en stelde een doordacht behandelplan op. Dankzij zijn professionele begeleiding en gerichte oefeningen heb ik enorme vooruitgang geboekt. Een aanrader voor iedereen die op zoek is naar deskundige en persoonlijke kinesitherapie!',
          image: require('../assets/images/work/01.jpg'),
      },
      
      ]
    }
  },
  actions: {
    getReviews() {
        return this.reviews;
    },

    getReview(id) {
        return this.reviews.find(r => r.id+"" === id+"");
    }
  }
});
